// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Y-JJ","insightsList":"newBusinessInsightsMenu_insightsList__1kSa0","active":"newBusinessInsightsMenu_active__2wigQ"};